module.exports = __webpack_public_path__ + "img/dan.c334672c.svg";